"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Shimmer = void 0;
var highlight = 'rgba(0, 0, 0, 0.0)'; // use theme-ui variables

var lowlight = 'rgba(0, 0, 0, 0.1)';
var Shimmer = {
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  backgroundImage: "linear-gradient(\n    to right, " + lowlight + " 0%,\n    " + highlight + " 0%,\n    " + lowlight + " 40%,\n    " + highlight + " 100%\n  )",
  backgroundRepeat: 'no-repeat',
  position: 'relative',
  height: '2.5em',
  width: '160px',
  marginBottom: '4px',
  animationDuration: '1.5s',
  animationFillMode: 'forwards',
  animationIterationCount: 'infinite',
  animationName: 'placeholderShimmer',
  animationTimingFunction: 'linear',
  '@keyframes placeholderShimmer': {
    '0%': {
      backgroundPosition: '-2000px 0'
    },
    '100%': {
      backgroundPosition: '2000px 0'
    }
  }
};
exports.Shimmer = Shimmer;